<template>
    <div id="weather-block-root">
        <div v-if="locationStr && forecasts" class="weatherBlockWrapper">
            <div class="weatherLocationWrapper">
                <span class="topSectionTitle">Weekly Weather Forecast</span>
                <div class="weatherLocation">
                    {{ locationStr }}
                </div>
            </div>
            <div class="weatherForecastWrapper">
                <div
                    v-for="(forecast, index) in forecasts"
                    :key="index"
                    :id="`${index}_forecast`"
                    class="forecast"
                >
                    <div class="forecastDateWrapper">
                        <span v-if="index == 0">Today</span
                        ><span v-else>{{ forecast.day }}</span>
                    </div>
                    <div class="forecastIconWrapper">
                        <i :class="getWeatherIcon(forecast.code)"></i>
                    </div>
                    <div class="forecastTempWrapper">
                        <span class="forecastTempMax">{{ forecast.high }}°</span
                        ><span class="forecastTempMin"
                            >{{ forecast.low }}°</span
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { weatherIcons } from "../helper";

export default {
    name: "weather-block",
    props: ["weatherData"],
    data() {
        return {
            weather: null,
        };
    },
    mounted() {
        this.weather = this.weatherData || null;

        const root = document.querySelector(`#weather-block-root`);
        if (root) {
            const resizeObserver = new ResizeObserver(els => {
                for (const el of els) {
                    if (el.contentRect && el.contentRect.height) {
                        const h = el.contentRect.height;
                        if (h < 20) {
                            root.style.display = "none";
                        } else root.style.display = "block";
                    }
                }
            });

            resizeObserver.observe(root);
        }
    },
    computed: {
        locationStr() {
            const { weather } = this;
            if (weather && weather.location) {
                let str = "";
                if (weather.location.city) str += weather.location.city;
                if (weather.location.city && weather.location.region)
                    str += ", ";
                if (weather.location.region) str += weather.location.region;

                if (str != "") return str;
            }
            return null;
        },
        forecasts() {
            const { weather } = this;
            if (weather && weather.forecasts && weather.forecasts.length >= 4)
                return weather.forecasts.slice(0, 4);
        },
    },
    methods: {
        getWeatherIcon(num) {
            return weatherIcons[num];
        },
    },
};
</script>

<style scoped>
#weather-block-root {
    padding-bottom: 35px;
}

#weather-block-root:empty {
    display: none;
}

.weatherForecastWrapper {
    display: block;
}

.weatherLocationWrapper {
    padding-bottom: 15px;
}

.weatherLocation {
    font-size: 1rem;
    margin-top: 25px;
    color: #545454;
}

.forecast {
    display: inline-block;
    padding-right: 2px;
    width: 76px;
    text-align: center;
}

.forecastIconWrapper {
    background-color: #4480ec;
    color: white;
    font-weight: bold;
    font-size: 1rem;
    box-sizing: border-box;
    padding: 10px 0px 5px;
}

.forecastDateWrapper {
    background-color: #0757e7;
    color: white;
    font-weight: bold;
    font-size: 1rem;
    box-sizing: border-box;
    padding: 10px 0px 5px;
}

.forecastIconWrapper i {
    font-size: 2.75rem;
    padding: 20px 0px;
}

.forecastTempWrapper {
    display: grid;
    grid-template-columns: auto 1fr auto;
    padding: 5px 10px;
    box-sizing: border-box;
}

.forecastTempMax {
    grid-column-start: 1;
    font-size: 1.2rem;
    color: #0757e7;
    font-weight: bold;
    margin-right: 2px;
}

.forecastTempMin {
    grid-column-start: 3;
    font-size: 0.9rem;
    color: #4480ec;
}
</style>
